module.exports = {
      id: "arcade-usage",
      viewBox: "0 0 19.915 20.731",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#arcade",
      toString: function () {
        return this.url;
      }
    }